import { useEffect, type FC, type PropsWithChildren } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { Meta } from '@xing-com/typography';

import { usePagination } from '../../hooks/use-pagination';
import { scrollToTop } from '../../utils';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';
import { MetaData } from '../meta-data';
import * as Styled from './subpage-layout.styles';

type SubpageLayoutProps = {
  headerText: string;
  description?: string;
  overriteBreadcrumbsNames?: { [route: string]: () => string };
};

export const SubpageLayout: FC<PropsWithChildren<SubpageLayoutProps>> = ({
  headerText,
  description,
  children,
  overriteBreadcrumbsNames,
}) => {
  const { isLoggedOut } = useLoginState();
  useEffect(() => scrollToTop(), []);
  const { activePage, isFirstPage } = usePagination();
  const currentUrl = global.location;

  const showBreadcrums = isLoggedOut;

  return (
    <Styled.SubpageLayout $showBreadcrums={showBreadcrums}>
      <MetaData
        index={isFirstPage}
        title={headerText}
        description={description ?? headerText}
        canonicalUrl={activePage ? currentUrl : undefined}
      />
      {showBreadcrums && (
        <Breadcrumbs overriteNames={overriteBreadcrumbsNames} />
      )}
      <Styled.HeaderLayout>
        {/* @ts-expect-error FIXME: SC6 */}
        <Styled.HeaderLayoutHeadline
          size="xxxlarge"
          sizeWide="xxxxlarge"
          sizeConfined="xxxxlarge"
        >
          {headerText}
        </Styled.HeaderLayoutHeadline>
        <Meta size="large">{description}</Meta>
      </Styled.HeaderLayout>
      {children}
    </Styled.SubpageLayout>
  );
};
